import Vue from 'vue';
import Router from 'vue-router';

import * as AllViews from '@/views';



Vue.use(Router);

export default new Router({
routes: [


{
path: '*',
redirect: 'logins',
},
{
path: '/abscences',
name: 'abscences',
component: ()=> AllViews.ReadAbscences(),
meta: {
pageTitle: 'Abscences',
breadcrumb: [
{
text: 'Abscences',
active: true,
},
],
},
},
{
path: '/annuaires',
name: 'annuaires',
component: ()=> AllViews.ReadAnnuaires(),
meta: {
pageTitle: 'Annuaires',
breadcrumb: [
{
text: 'Annuaires',
active: true,
},
],
},
},
{
path: '/calendriers',
name: 'calendriers',
component: ()=> AllViews.ReadCalendriers(),
meta: {
pageTitle: 'Calendriers',
breadcrumb: [
{
text: 'Calendriers',
active: true,
},
],
},
},
{
path: '/categories',
name: 'categories',
component: ()=> AllViews.ReadCategories(),
meta: {
pageTitle: 'Categories',
breadcrumb: [
{
text: 'Categories',
active: true,
},
],
},
},
{
path: '/chantiers',
name: 'chantiers',
component: ()=> AllViews.ReadChantiers(),
meta: {
pageTitle: 'Chantiers',
breadcrumb: [
{
text: 'Chantiers',
active: true,
},
],
},
},
{
path: '/clients',
name: 'clients',
component: ()=> AllViews.ReadClients(),
meta: {
pageTitle: 'Clients',
breadcrumb: [
{
text: 'Clients',
active: true,
},
],
},
},
{
path: '/coefficients',
name: 'coefficients',
component: ()=> AllViews.ReadCoefficients(),
meta: {
pageTitle: 'Coefficients',
breadcrumb: [
{
text: 'Coefficients',
active: true,
},
],
},
},
{
path: '/conges',
name: 'conges',
component: ()=> AllViews.ReadConges(),
meta: {
pageTitle: 'Conges',
breadcrumb: [
{
text: 'Conges',
active: true,
},
],
},
},
{
path: '/contrats',
name: 'contrats',
component: ()=> AllViews.ReadContrats(),
meta: {
pageTitle: 'Contrats',
breadcrumb: [
{
text: 'Contrats',
active: true,
},
],
},
},
{
path: '/corpsetats',
name: 'corpsetats',
component: ()=> AllViews.ReadCorpsetats(),
meta: {
pageTitle: 'Corpsetats',
breadcrumb: [
{
text: 'Corpsetats',
active: true,
},
],
},
},
{
path: '/designations',
name: 'designations',
component: ()=> AllViews.ReadDesignations(),
meta: {
pageTitle: 'Designations',
breadcrumb: [
{
text: 'Designations',
active: true,
},
],
},
},
{
path: '/directions',
name: 'directions',
component: ()=> AllViews.ReadDirections(),
meta: {
pageTitle: 'Directions',
breadcrumb: [
{
text: 'Directions',
active: true,
},
],
},
},
{
path: '/echelons',
name: 'echelons',
component: ()=> AllViews.ReadEchelons(),
meta: {
pageTitle: 'Echelons',
breadcrumb: [
{
text: 'Echelons',
active: true,
},
],
},
},
{
path: '/entreestocks',
name: 'entreestocks',
component: ()=> AllViews.ReadEntreestocks(),
meta: {
pageTitle: 'Entreestocks',
breadcrumb: [
{
text: 'Entreestocks',
active: true,
},
],
},
},
{
path: '/extrasdatas',
name: 'extrasdatas',
component: ()=> AllViews.ReadExtrasdatas(),
meta: {
pageTitle: 'Extrasdatas',
breadcrumb: [
{
text: 'Extrasdatas',
active: true,
},
],
},
},
{
path: '/familles',
name: 'familles',
component: ()=> AllViews.ReadFamilles(),
meta: {
pageTitle: 'Familles',
breadcrumb: [
{
text: 'Familles',
active: true,
},
],
},
},
{
path: '/files',
name: 'files',
component: ()=> AllViews.ReadFiles(),
meta: {
pageTitle: 'Files',
breadcrumb: [
{
text: 'Files',
active: true,
},
],
},
},
{
path: '/fonctions',
name: 'fonctions',
component: ()=> AllViews.ReadFonctions(),
meta: {
pageTitle: 'Fonctions',
breadcrumb: [
{
text: 'Fonctions',
active: true,
},
],
},
},
{
path: '/fournitures',
name: 'fournitures',
component: ()=> AllViews.ReadFournitures(),
meta: {
pageTitle: 'Fournitures',
breadcrumb: [
{
text: 'Fournitures',
active: true,
},
],
},
},
{
path: '/groupescorpsetats',
name: 'groupescorpsetats',
component: ()=> AllViews.ReadGroupescorpsetats(),
meta: {
pageTitle: 'Groupescorpsetats',
breadcrumb: [
{
text: 'Groupescorpsetats',
active: true,
},
],
},
},
{
path: '/homes',
name: 'homes',
component: ()=> AllViews.ReadHomes(),
meta: {
pageTitle: 'Homes',
breadcrumb: [
{
text: 'Homes',
active: true,
},
],
},
},
{
path: '/inventaires',
name: 'inventaires',
component: ()=> AllViews.ReadInventaires(),
meta: {
pageTitle: 'Inventaires',
breadcrumb: [
{
text: 'Inventaires',
active: true,
},
],
},
},
{
path: '/jobs',
name: 'jobs',
component: ()=> AllViews.ReadJobs(),
meta: {
pageTitle: 'Jobs',
breadcrumb: [
{
text: 'Jobs',
active: true,
},
],
},
},
{
path: '/joursferies',
name: 'joursferies',
component: ()=> AllViews.ReadJoursferies(),
meta: {
pageTitle: 'Joursferies',
breadcrumb: [
{
text: 'Joursferies',
active: true,
},
],
},
},
{
path: '/logins',
name: 'logins',
component: ()=> AllViews.ReadLogins(),
meta: {
pageTitle: 'Logins',
breadcrumb: [
{
text: 'Logins',
active: true,
},
],
},
},
{
path: '/logs',
name: 'logs',
component: ()=> AllViews.ReadLogs(),
meta: {
pageTitle: 'Logs',
breadcrumb: [
{
text: 'Logs',
active: true,
},
],
},
},
{
path: '/lots',
name: 'lots',
component: ()=> AllViews.ReadLots(),
meta: {
pageTitle: 'Lots',
breadcrumb: [
{
text: 'Lots',
active: true,
},
],
},
},
{
path: '/materiels',
name: 'materiels',
component: ()=> AllViews.ReadMateriels(),
meta: {
pageTitle: 'Materiels',
breadcrumb: [
{
text: 'Materiels',
active: true,
},
],
},
},
{
path: '/model_has_permissions',
name: 'model_has_permissions',
component: ()=> AllViews.ReadModel_has_permissions(),
meta: {
pageTitle: 'Model_has_permissions',
breadcrumb: [
{
text: 'Model_has_permissions',
active: true,
},
],
},
},
{
path: '/model_has_roles',
name: 'model_has_roles',
component: ()=> AllViews.ReadModel_has_roles(),
meta: {
pageTitle: 'Model_has_roles',
breadcrumb: [
{
text: 'Model_has_roles',
active: true,
},
],
},
},
{
path: '/mouvementsstocks',
name: 'mouvementsstocks',
component: ()=> AllViews.ReadMouvementsstocks(),
meta: {
pageTitle: 'Mouvementsstocks',
breadcrumb: [
{
text: 'Mouvementsstocks',
active: true,
},
],
},
},
{
path: '/mouvementsstocksdetails',
name: 'mouvementsstocksdetails',
component: ()=> AllViews.ReadMouvementsstocksdetails(),
meta: {
pageTitle: 'Mouvementsstocksdetails',
breadcrumb: [
{
text: 'Mouvementsstocksdetails',
active: true,
},
],
},
},
{
path: '/nationalites',
name: 'nationalites',
component: ()=> AllViews.ReadNationalites(),
meta: {
pageTitle: 'Nationalites',
breadcrumb: [
{
text: 'Nationalites',
active: true,
},
],
},
},
{
path: '/oauth_access_tokens',
name: 'oauth_access_tokens',
component: ()=> AllViews.ReadOauth_access_tokens(),
meta: {
pageTitle: 'Oauth_access_tokens',
breadcrumb: [
{
text: 'Oauth_access_tokens',
active: true,
},
],
},
},
{
path: '/oauth_auth_codes',
name: 'oauth_auth_codes',
component: ()=> AllViews.ReadOauth_auth_codes(),
meta: {
pageTitle: 'Oauth_auth_codes',
breadcrumb: [
{
text: 'Oauth_auth_codes',
active: true,
},
],
},
},
{
path: '/oauth_clients',
name: 'oauth_clients',
component: ()=> AllViews.ReadOauth_clients(),
meta: {
pageTitle: 'Oauth_clients',
breadcrumb: [
{
text: 'Oauth_clients',
active: true,
},
],
},
},
{
path: '/oauth_personal_access_clients',
name: 'oauth_personal_access_clients',
component: ()=> AllViews.ReadOauth_personal_access_clients(),
meta: {
pageTitle: 'Oauth_personal_access_clients',
breadcrumb: [
{
text: 'Oauth_personal_access_clients',
active: true,
},
],
},
},
{
path: '/oauth_refresh_tokens',
name: 'oauth_refresh_tokens',
component: ()=> AllViews.ReadOauth_refresh_tokens(),
meta: {
pageTitle: 'Oauth_refresh_tokens',
breadcrumb: [
{
text: 'Oauth_refresh_tokens',
active: true,
},
],
},
},
{
path: '/pays',
name: 'pays',
component: ()=> AllViews.ReadPays(),
meta: {
pageTitle: 'Pays',
breadcrumb: [
{
text: 'Pays',
active: true,
},
],
},
},
{
path: '/permissions',
name: 'permissions',
component: ()=> AllViews.ReadPermissions(),
meta: {
pageTitle: 'Permissions',
breadcrumb: [
{
text: 'Permissions',
active: true,
},
],
},
},
{
path: '/role_has_permission',
name: 'role_has_permission',
component: ()=> AllViews.ReadRole_has_permission(),
meta: {
pageTitle: 'Role_has_permission',
breadcrumb: [
{
text: 'Role_has_permission',
active: true,
},
],
},
},
{
path: '/role_has_permissions',
name: 'role_has_permissions',
component: ()=> AllViews.ReadRole_has_permissions(),
meta: {
pageTitle: 'Role_has_permissions',
breadcrumb: [
{
text: 'Role_has_permissions',
active: true,
},
],
},
},
{
path: '/roles',
name: 'roles',
component: ()=> AllViews.ReadRoles(),
meta: {
pageTitle: 'Roles',
breadcrumb: [
{
text: 'Roles',
active: true,
},
],
},
},
{
path: '/services',
name: 'services',
component: ()=> AllViews.ReadServices(),
meta: {
pageTitle: 'Services',
breadcrumb: [
{
text: 'Services',
active: true,
},
],
},
},
{
path: '/sexes',
name: 'sexes',
component: ()=> AllViews.ReadSexes(),
meta: {
pageTitle: 'Sexes',
breadcrumb: [
{
text: 'Sexes',
active: true,
},
],
},
},
{
path: '/sites',
name: 'sites',
component: ()=> AllViews.ReadSites(),
meta: {
pageTitle: 'Sites',
breadcrumb: [
{
text: 'Sites',
active: true,
},
],
},
},
{
path: '/situations',
name: 'situations',
component: ()=> AllViews.ReadSituations(),
meta: {
pageTitle: 'Situations',
breadcrumb: [
{
text: 'Situations',
active: true,
},
],
},
},
{
path: '/soldables',
name: 'soldables',
component: ()=> AllViews.ReadSoldables(),
meta: {
pageTitle: 'Soldables',
breadcrumb: [
{
text: 'Soldables',
active: true,
},
],
},
},
{
path: '/soustraitants',
name: 'soustraitants',
component: ()=> AllViews.ReadSoustraitants(),
meta: {
pageTitle: 'Soustraitants',
breadcrumb: [
{
text: 'Soustraitants',
active: true,
},
],
},
},
{
path: '/stocks',
name: 'stocks',
component: ()=> AllViews.ReadStocks(),
meta: {
pageTitle: 'Stocks',
breadcrumb: [
{
text: 'Stocks',
active: true,
},
],
},
},
{
path: '/taches',
name: 'taches',
component: ()=> AllViews.ReadTaches(),
meta: {
pageTitle: 'Taches',
breadcrumb: [
{
text: 'Taches',
active: true,
},
],
},
},
{
path: '/typesabscences',
name: 'typesabscences',
component: ()=> AllViews.ReadTypesabscences(),
meta: {
pageTitle: 'Typesabscences',
breadcrumb: [
{
text: 'Typesabscences',
active: true,
},
],
},
},
{
path: '/typesbatiments',
name: 'typesbatiments',
component: ()=> AllViews.ReadTypesbatiments(),
meta: {
pageTitle: 'Typesbatiments',
breadcrumb: [
{
text: 'Typesbatiments',
active: true,
},
],
},
},
{
path: '/typesbatimentsfournitures',
name: 'typesbatimentsfournitures',
component: ()=> AllViews.ReadTypesbatimentsfournitures(),
meta: {
pageTitle: 'Typesbatimentsfournitures',
breadcrumb: [
{
text: 'Typesbatimentsfournitures',
active: true,
},
],
},
},
{
path: '/typesbatimentstaches',
name: 'typesbatimentstaches',
component: ()=> AllViews.ReadTypesbatimentstaches(),
meta: {
pageTitle: 'Typesbatimentstaches',
breadcrumb: [
{
text: 'Typesbatimentstaches',
active: true,
},
],
},
},
{
path: '/typesbatimentsvalidations',
name: 'typesbatimentsvalidations',
component: ()=> AllViews.ReadTypesbatimentsvalidations(),
meta: {
pageTitle: 'Typesbatimentsvalidations',
breadcrumb: [
{
text: 'Typesbatimentsvalidations',
active: true,
},
],
},
},
{
path: '/users',
name: 'users',
component: ()=> AllViews.ReadUsers(),
meta: {
pageTitle: 'Users',
breadcrumb: [
{
text: 'Users',
active: true,
},
],
},
},
{
path: '/variables',
name: 'variables',
component: ()=> AllViews.ReadVariables(),
meta: {
pageTitle: 'Variables',
breadcrumb: [
{
text: 'Variables',
active: true,
},
],
},
},
{
path: '/villes',
name: 'villes',
component: ()=> AllViews.ReadVilles(),
meta: {
pageTitle: 'Villes',
breadcrumb: [
{
text: 'Villes',
active: true,
},
],
},
},
{
path: '/websockets_statistics_entries',
name: 'websockets_statistics_entries',
component: ()=> AllViews.ReadWebsockets_statistics_entries(),
meta: {
pageTitle: 'Websockets_statistics_entries',
breadcrumb: [
{
text: 'Websockets_statistics_entries',
active: true,
},
],
},
},
{
path: '/zones',
name: 'zones',
component: ()=> AllViews.ReadZones(),
meta: {
pageTitle: 'Zones',
breadcrumb: [
{
text: 'Zones',
active: true,
},
],
},
},

],
mode: 'history'
});
